import s from '../Button.module.scss';
import { Button, IButtonProps } from '../Button';

export const ButtonRed = ({ children, className, onClick }: IButtonProps) => {
	return (
		<Button
			children={children}
			className={`${className} ${s.buttonRed}`}
			onClick={onClick}
		/>
	);
};
